<ng-container *transloco="let t; read: 'assignment'" >
  <ng-container *ngIf="vm$ | async as vm">
    <h2>{{t('scheduler')}}</h2>
    <app-scheduler-shared
        [assignmentId]="vm.assignment.id"
        [schedulerRessources]="vm.schedulerRessources"
        [events]="vm.events"
        [holidays]="vm.holidays"
        [searchRequest]="searchRequest"
        [absenceGroups]="vm.absenceGroups"
        [isLoading]="isLoading"
        (onReloadEvents)="onReloadEvents()"
  ></app-scheduler-shared>
</ng-container>
</ng-container>